import {
  get,
  post,
  getJson
} from '@/utils/datacom'


export const randonBase64ImgValidateCode = (option) => get('api/user/RandonBase64ImgValidateCode',option) //获取图形验证码
export const sendValidateCodeWithImgValidate = (option) => get('api/user/SendValidateCodeWithImgValidate',option) //发送短信验证码
export const nomalLogin = (option) => post("api/user/Login",option); //普通登录
export const getBanks = (option) => get("api/user/GetBanks", option);//银行卡列表
export const getBankCard = (option) => get("api/user/GetBankCard", option);//获取银行卡信息
export const saveBankCard = (option) => post("api/user/SaveBankCard", option);//保存银行卡
export const getPaymentFlow = (option) => get("api/pay/PaymentFlow", option);//流水列表
export const loadPayInfo = (option) => get("api/pay/LoadPayInfo", option);//获取钱包信息

export const error = (option) => post("api/Log/Error", option) //提交接口异常
export const gettotalAccount = (option) => get("api/Pay/TotalAccount", option) //获取累计收益
export const getCarOnwerCars = (option) => get("api/Car/GetCarOnwerCars", option) //获取车辆申请列表
export const getOnwerCars = (option) => get("api/Car/GetOwnerCars", option) //获取车辆列表
export const getOnlineDate = (option) => get("api/Pay/GetOnlineDate", option) //获取上线开始时间
export const getIncomeInfo = (option) => get("api/Pay/GetIncomeInfo", option) //获取月度收益详情
export const apply = (option) => post("api/car/Apply", option) //提交车辆信息
export const getShopCitys = (option) => get("api/Shop/GetShopCitys", option) //查询共享渠道得城市列表
export const getCurrentMemberInfo = (option) => get("api/user/GetCurrentMemberInfo", option) //获取用户信息
export const getWithdrawalInfo = (option) => get("api/pay/GetWithdrawalInfo",option) //获取提现信息
export const sendValidateCode = (option) => get("api/pay/SendValidateCode",option) //发送提现验证码
export const cashWithdrawal = (option) => post("api/pay/CashWithdrawal",option) //确认提现
export const searchAddress = (option) => get("api/shop/SearchAddress", option) //搜索地址查询附近位置
export const getorders = (option) => get("api/car/orders", option); //获取订单列表
export const getcarInfo = (option) => get("api/car/CarInfo", option) //车辆管家
export const peccancyList = (option) => get("api/car/PeccancyList", option) //违章记录列表
export const accidentList = (option) => get("api/car/AccidentList", option) //事故记录列表
export const maintainList = (option) => get("api/car/MaintainList", option) //保养记录列表
export const rentTime = (option) => get("api/car/RentTime", option) //可租时间列表
export const inviteOwnersInfo = (option) => get("api/user/InviteOwnersInfo", option) //获取邀请信息
export const inviteMemberRecords = (option) => get("api/user/InviteMemberRecords", option) //获取邀请记录
export const inviteBonusRecords = (option) => get("api/user/InviteBonusRecords", option) //获取奖励记录



// WEBPACK FOOTER //
// ./src/utils/api.js